import GeoDistributionInfo from './GeoDistributionInfo';

export default GeoDistributionInfo;
